<nav>
    <ul class="list-none">
        <li class="pt-2" *ngFor="let item of menu">
            <app-sidebar-item [item]="item" />
        </li>
    </ul>
</nav>
